const courseStatus = [
  {
    id: 'DRAFT',
    name: 'DRAFT',
  },
  {
    id: 'PUBLISHED',
    name: 'PUBLISHED',
  },
];

export default courseStatus;
